import { Injectable, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { of as observableOf, Observable } from 'rxjs';
import { HttpRequestService } from '../../services/http-request.service';
import * as myGlobals from '../../../shared/globalcontants';
import { APIServiceProviderService } from '../../services/APIServices/APIServiceProviderService/APIServiceProviderService';
import { InventoryEntity } from '../../models/Inventory/InventoryEntity';


// import * as myGlobals from '../shared/globalcontants';
// import { APIServiceProviderService } from '../shared/services/APIServices/APIServiceProviderService/APIServiceProviderService';
//
// import { InventoryEntity } from '../shared/models/Inventory/InventoryEntity';



@Injectable({
  providedIn: 'root',
})
export class AutocompleteserversideService implements OnInit {
  constructor( public _hs: HttpRequestService) { }
  getOptionArray() {
    return this._hs.GetHttpRequest(myGlobals.LocalJsonUrl + myGlobals.LocalJson['inventoryList']);
  }
 ngOnInit() {

 }

 onResize(e) {

 }

}
